//React
import { FunctionComponent, ReactNode } from "react"

//Interfaces
import { I_SafetyEvent, I_VehicleIncidentsTableItem } from "src/pages/vehicle_incidents/interfaces"

//Shared Components
import HoverRevealActions from "src/components/common/HoverRevealActions"

//Local Components
import VehicleIncidentsTableBodyTDIconBubble from "./VehicleIncidentsTableBodyTDIconBubble"
import VehicleIncidentsTableBodyTDCellText from "./VehicleIncidentsTableBodyTDCellText"
import VehicleIncidentsTableBodyTDRowMenu from "./VehicleIncidentsTableBodyTDRowMenu"

interface Props {
    tblItem: I_VehicleIncidentsTableItem
    eventItem: I_SafetyEvent
    i: number
    j: number
    handleLinkClick: (id: number) => void
    clickedLinks: Set<number>
    loader: number
}

const VehicleIncidentsTableBodyTD: FunctionComponent<Props> = ({
    tblItem,
    eventItem,
    i,
    j,
    handleLinkClick,
    clickedLinks,
    loader
}) => {
    const rawValue = eventItem[tblItem.key as keyof I_SafetyEvent]
    const data: ReactNode =
        tblItem.VISFunction ? tblItem.VISFunction(rawValue) : rawValue

    const isLink = tblItem.key === "SafetyEventUrl"
    const hasBeenClicked = clickedLinks.has(eventItem.ObjectID)
    const firstCell = j === 0
    const isActionsColumn = !!tblItem.isActionsColumn
    const labels = firstCell ? (eventItem.Label ?? "").split(",").map(l => l.trim()).filter(Boolean) : []

    return (
        <td
            key={j}
            id={`vitb-td-${i}-${j}-${eventItem.ID}`}
            className="VehicleIncidentsTableBodyTD"
        >
            <div
                className={`VehicleIncidentsTableBodyTDInner ${firstCell ? "VehicleIncidentsTableBodyTDInnerFirstCell" : ""
                    }`}
            >
                {!isActionsColumn && !firstCell && (
                    <VehicleIncidentsTableBodyTDCellText
                        isLink={isLink}
                        hasBeenClicked={hasBeenClicked}
                        data={data}
                        title={typeof data === "string" ? data : undefined}
                        onClick={() => handleLinkClick(eventItem.ObjectID)}
                    />
                )}

                {firstCell && (
                    <VehicleIncidentsTableBodyTDIconBubble
                        label={labels}
                        eventId={eventItem.ID}
                    />
                )}

                {isActionsColumn && loader < 0 && (
                    <HoverRevealActions
                        className="VehicleIncidentsTableTableRowMenu"
                        id={`row-menu-${eventItem.ID}`}
                        label="Incident actions"
                    >
                        <VehicleIncidentsTableBodyTDRowMenu objectId={eventItem.ObjectID} />
                    </HoverRevealActions>
                )}
            </div>
        </td>
    )
}

export default VehicleIncidentsTableBodyTD
